<template>
  <el-table-column
    prop="price_per_pack"
    label="Egységár"
    align="right"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.price_per_pack | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'price_per_pack',
};
</script>
